var map = {
	"./00-welcome.js": 20,
	"./01-html.js": 21,
	"./02-texts.js": 22,
	"./03-links.js": 23,
	"./04-css.js": 24,
	"./05-rules.js": 25,
	"./06-colors.js": 26,
	"./07-fonts.js": 27,
	"./08-align.js": 28,
	"./09-listas.js": 29,
	"./10-table.js": 30,
	"./11-containers.js": 31,
	"./12-dimensions.js": 32,
	"./13-borders.js": 33,
	"./14-outlines.js": 34,
	"./15-spacing.js": 35,
	"./16-display.js": 36,
	"./17-position.js": 37,
	"./18-forms.js": 38,
	"./19-buttons.js": 39,
	"./99-credits.js": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;